import { forwardRef } from "react";
import type { AppIcon } from "@/shared/icons/types";

export const IcloudMoreIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 14.8C11.7555 14.8 14.8 11.7555 14.8 8C14.8 4.24446 11.7555 1.2 8 1.2C4.24446 1.2 1.2 4.24446 1.2 8C1.2 11.7555 4.24446 14.8 8 14.8ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#1677FF"
        />
        <path
          d="M4.01822 9C3.45552 9 3 8.55673 3 8.00264C3 7.44855 3.45552 7 4.01822 7C4.58092 7 5.03108 7.44855 5.03108 8.00264C5.03108 8.55673 4.58092 9 4.01822 9ZM8 9C7.4373 9 6.98178 8.55673 6.98178 8.00264C6.98178 7.44855 7.4373 7 8 7C8.5627 7 9.01286 7.44855 9.01286 8.00264C9.01286 8.55673 8.5627 9 8 9ZM11.9818 9C11.4191 9 10.9636 8.55673 10.9636 8.00264C10.9636 7.44855 11.4191 7 11.9818 7C12.5445 7 13 7.44855 13 8.00264C13 8.55673 12.5445 9 11.9818 9Z"
          fill="#1677FF"
        />
      </svg>
    );
  },
);

export const IcloudUploadIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 13, height = 17, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 13 17"
        fill="none"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.49634 10.7149C6.18141 10.7149 5.91775 10.4586 5.91775 10.151V2.69521L5.96169 1.60394L5.55155 2.03606L4.41634 3.24451C4.3138 3.36169 4.15268 3.42028 4.01352 3.42028C3.70592 3.42028 3.4862 3.20056 3.4862 2.90761C3.4862 2.74648 3.55211 2.6293 3.66197 2.51944L6.07155 0.190423C6.22535 0.0439437 6.34986 0 6.49634 0C6.65014 0 6.77465 0.0439437 6.92113 0.190423L9.33803 2.51944C9.44789 2.6293 9.50648 2.74648 9.50648 2.90761C9.50648 3.20056 9.27944 3.42028 8.97183 3.42028C8.83268 3.42028 8.67887 3.36169 8.57634 3.24451L7.44845 2.03606L7.03831 1.60394L7.08225 2.69521V10.151C7.08225 10.4586 6.81127 10.7149 6.49634 10.7149ZM2.29972 16.4569C0.769014 16.4569 0 15.7025 0 14.1865V6.95775C0 5.44169 0.769014 4.68732 2.29972 4.68732H4.54084V5.86648H2.31437C1.58197 5.86648 1.17915 6.25465 1.17915 7.01634V14.1279C1.17915 14.8896 1.58197 15.2777 2.31437 15.2777H10.6783C11.4034 15.2777 11.8208 14.8896 11.8208 14.1279V7.01634C11.8208 6.25465 11.4034 5.86648 10.6783 5.86648H8.45183V4.68732H10.7003C12.231 4.68732 13 5.44901 13 6.95775V14.1865C13 15.6952 12.231 16.4569 10.7003 16.4569H2.29972Z"
          fill="#1677FF"
        />
      </svg>
    );
  },
);
